import { styled } from '@material-ui/core';

export const Center = styled('div')({
  textAlign: 'center',
  padding: 20,
  width: '100%'
});
